import App from './App.svelte';
const app = new App({
	target: document.body,
	// hydrate: true,
	props: {
		name: 'world',
		userCard: [],
		empleados: [
		{
			'id': "jt-benavides",
			'file': "jt_benavides.vcf",
			'photo': "jt_benavides.png",
			'nombres': 'JT Benavides',
			'cargo': 'Managing Partner',
			'descripcion': 'Poviard Private Equity',
			'movil': '+1 713 876 1692',
			'fijo': '',
			'fax': '',
			'email': 'jt@poviard.com',
			'empresa': '',
			'direccion' : '1725 Hughes Landing Blvd 11th Floor. The Woodlands, TX 77380',
			'ubicacion' : 'latitud y long',
			'web_page': [{
				'name': 'Web Site',
				'link': 'https://poviard.com/'
			},{
				'name': 'Web Site',
				'link': 'https://benitan.com/'
			}],
			'redes_sociales': [{
				'red' : 'facebook',
				'link' : ''
			},{
				'red' : 'instagram',
				'link' : ''
			},{
				'red' : 'linkedin',
				'link' : ''
			},{
				'red' : 'whatsapp',
				'link' : ''
			},{
				'red' : 'twitter',
				'link' : ''
			}]	
		},{
			'id': "eduardo-benavides",
			'file': "eduardo_benavides.vcf",
			'photo': "eduardo_benavides.png",
			'nombres': 'Eduardo Benavides',
			'cargo': 'Sales director',
			'descripcion': 'Radianty LLC',
			'movil': '+1 281 851 1084',
			'fijo': '',
			'fax': '',
			'email': 'Eduardo@iradianty.com',
			'empresa': '',
			'direccion' : '1725 Hughes Landing Blvd 11th Floor. The Woodlands, TX 77380. ',
			'ubicacion' : '',
			'web_page': [{
				'name': 'Web Site',
				'link': 'http://www.iradianty.com/'
			}],
			'redes_sociales': [{
				'red' : 'facebook',
				'link' : ''
			},{
				'red' : 'instagram',
				'link' : ''
			},{
				'red' : 'linkedin',
				'link' : ''
			},{
				'red' : 'whatsapp',
				'link' : ''
			},{
				'red' : 'twitter',
				'link' : ''
			}]		
		},{
			'id': "dean-burden",
			'file': "dean_burden.vcf",
			'photo': "dean_burden.png",
			'nombres': 'Dean Burden',
			'cargo': 'Managing Partner',
			'descripcion': 'Poviard Private Equity',
			'movil': '+1 281 865 7985',
			'fijo': '',
			'fax': '',
			'email': 'dean@poviard.com',
			'empresa': '',
			'direccion' : '1725 Hughes Landing Blvd 11th Floor. The Woodlands, TX 77380.',
			'ubicacion' : '',
			'web_page': [{
				'name': 'Web Site',
				'link': 'https://poviard.com/'
			}],
			'redes_sociales': [{
				'red' : 'facebook',
				'link' : ''
			},{
				'red' : 'instagram',
				'link' : ''
			},{
				'red' : 'linkedin',
				'link' : ''
			},{
				'red' : 'whatsapp',
				'link' : ''
			},{
				'red' : 'twitter',
				'link' : ''
			}]		
		},{
			'id': "manfred-jeske",
			'file': "manfred_jeske.vcf",
			'photo': "manfred_jeske.png",
			'nombres': 'Manfred Jeske',
			'cargo': 'Chief Investment Officer',
			'descripcion': 'Poviard Private Equity',
			'movil': '+1 479 684 7555',
			'fijo': '',
			'fax': '',
			'email': 'manfred@poviard.com',
			'empresa': '',
			'direccion' : '1725 Hughes Landing Blvd 11th Floor. The Woodlands, TX 77380.',
			'ubicacion' : '',
			'web_page': [{
				'name': 'Web Site',
				'link': 'https://poviard.com/'
			}],
			'redes_sociales': [{
				'red' : 'facebook',
				'link' : ''
			},{
				'red' : 'instagram',
				'link' : ''
			},{
				'red' : 'linkedin',
				'link' : ''
			},{
				'red' : 'whatsapp',
				'link' : ''
			},{
				'red' : 'twitter',
				'link' : ''
			}]		
		}],
	}
});

export default app;